export const PostApprovalFormType = {
    CTC_CTI: 'CTC_CTI',
    COMMENT: 'COMMENT',
    FORM: 'FORM',
};

/** Document Types */
export const INIT_APPLICATION = 0;
export const AMENDMENT_FORM = 1;

/** Post-approval activities: */
export const SUSAR_REPORT = 2;
export const MISCELLANEOUS_REPORT = 3;
export const FINAL_REPORT = 4;
export const CTC = 5;
export const CTI = 6;
export const PROGRESS_REPORT = 7;
export const PROTOCOL_DEVIATION_REPORT = 8;
export const LOCAL_SAE_REPORT = 9;
/** Document Types END */

/** Type of Review */
export const FULL_REVIEW = 0;
export const PHASE_1_REVIEW = 1;
export const EXPEDITED_REVIEW = 2;
/** Type of Review END */

export const documentTypeLookUp = {
    [INIT_APPLICATION]: {
        key: INIT_APPLICATION,
        display: 'Initial Application',
    },
    [AMENDMENT_FORM]: {
        key: AMENDMENT_FORM,
        display: 'Amendment Form',
    },
    [SUSAR_REPORT]: {
        key: SUSAR_REPORT,
        display: 'SUSAR Report',
    },
    [MISCELLANEOUS_REPORT]: {
        key: MISCELLANEOUS_REPORT,
        display: 'Miscellaneous Report',
    },
    [FINAL_REPORT]: {
        key: FINAL_REPORT,
        display: 'Final Report',
    },
    [CTC]: {
        key: CTC,
        display: 'CTC',
    },
    [CTI]: {
        key: CTI,
        display: 'CTI',
    },
    [PROGRESS_REPORT]: {
        key: PROGRESS_REPORT,
        display: 'Progress Report',
    },
    [PROTOCOL_DEVIATION_REPORT]: {
        key: PROTOCOL_DEVIATION_REPORT,
        display: 'Protocol Deviation Report',
    },
    [LOCAL_SAE_REPORT]: {
        key: LOCAL_SAE_REPORT,
        display: 'Local SAE Report',
    },
}

export const reviewResultDecision = [
    {
        key: 0,
        display: 'Approved',
    },
    {
        key: 1,
        display: 'Acknowledged',
    },
    {
        key: 2,
        display: 'Channel for Full Review',
    },
    {
        key: 3,
        display: 'Request for Modification',
    },
    {
        key: 4,
        display: 'Disapproved',
    },
];

export const documentTypePaths = {
    [AMENDMENT_FORM]: '/post-approval-document/application-amendment-detail?id=',
    [SUSAR_REPORT]: '/SUSAR-report?reportId=',
    [MISCELLANEOUS_REPORT]: '/miscellaneous-report?reportId=',
    [FINAL_REPORT]: '/final-report?reportId=',
    [CTC]: '/view-ctc?reportId=',
    [CTI]: '/view-cti?reportId=',
    [PROGRESS_REPORT]: '/progress-report?reportId=',
    [PROTOCOL_DEVIATION_REPORT]: '/protocol-deviation?reportId=',
    [LOCAL_SAE_REPORT]: '/SAE-report?reportId=',
};